import { render, staticRenderFns } from "./AlumniNetwork.vue?vue&type=template&id=01d2206e&scoped=true"
import script from "./AlumniNetwork.vue?vue&type=script&lang=js"
export * from "./AlumniNetwork.vue?vue&type=script&lang=js"
import style0 from "./AlumniNetwork.vue?vue&type=style&index=0&id=01d2206e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2206e",
  null
  
)

export default component.exports